import { render, staticRenderFns } from "./vehicleTypeItem.vue?vue&type=template&id=c2b7579c&scoped=true&"
import script from "./vehicleTypeItem.vue?vue&type=script&lang=js&"
export * from "./vehicleTypeItem.vue?vue&type=script&lang=js&"
import style0 from "./vehicleTypeItem.vue?vue&type=style&index=0&id=c2b7579c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b7579c",
  null
  
)

export default component.exports